var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.6,504.4c-99.6,0-199.1,0-298.7,0c-4.4-1.4-9.2-2.2-13.3-4.3c-16.2-8.1-23.6-21.8-23.6-39.6c0-83.7,0-167.4,0-251.1 c0-12.2,3-15.3,15.1-15.3c8.7,0,17.3,0,26.4,0c0-13.4,0-26.1,0-38.9c-0.1-39.6,12.8-74.4,40.6-102.6c38-38.5,84.2-52.3,137-40.6 c64,14.2,110.8,71.8,111.7,137.9c0.2,12.9,0.1,25.8,0.2,38.8c0,1.7,0,3.4,0,5.4c10.1,0,19.4,0,28.8,0c8.6,0,12.6,4,12.6,12.4 c0,85.1,0.1,170.3,0,255.4c0,14.1-5.2,26.2-17,34.1C419.5,499.9,412.2,501.6,405.6,504.4z M338.8,194c0-14.9,0.2-29.5,0-44 c-0.3-17.7-5.9-33.7-17-47.5c-20.9-26-48.3-37.1-81.1-30.7c-33.2,6.5-54.8,27-64.1,59.6c-5.7,20.2-2.3,41.1-2.8,61.7 c0,0.2,0.4,0.5,0.7,0.8C229,194,283.6,194,338.8,194z M255.9,421.7c6.1,0,12.3,0.1,18.4,0c9.7-0.1,13.8-5,12.7-14.5 c-2.1-17.6-4-35.3-5.8-52.9c-0.1-1.4,0.6-3.5,1.7-4.4c11-9.9,15.7-21.9,14.3-36.7c-2.3-23.5-27.4-41.2-50.3-35 c-16.4,4.4-27.2,14.9-30.8,31.4c-3.5,15.7,1.3,29.3,13.4,40.2c1.2,1,2.1,3.3,1.9,4.8c-1.8,17.8-3.9,35.6-5.9,53.4 c-1,8.7,3.2,13.6,12,13.8C243.6,421.8,249.7,421.7,255.9,421.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.8b84fcce739abee6f752dd0277aaf067.svg";
export { ForwardRef as ReactComponent };